import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { IntegrationsPage } from "@/components/integrations/integrations-page";

// Vive en `integrations/index.tsx` (no en `integrations.tsx`): asi no es la
// ruta padre de `integrations/$connectionId` (sin `<Outlet />` el detalle no
// se pintaria). Mismo criterio que `scripts/`.
export const Route = createFileRoute("/_authenticated/settings/_layout/integrations/")({
  component: IntegrationsSettingsPage,
});

function IntegrationsSettingsPage() {
  return (
    <RouteGuardPermissions permissions={[{ module: "integrations", actions: ["read"] }]}>
      <IntegrationsPage />
    </RouteGuardPermissions>
  );
}
